export const evt = {
  FADE_OUT_AUDIO: 'fadeOutAudio',
  FADE_IN_AUDIO: 'fadeInAudio',
}